import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from '../../../crud/auth.crud';
import { getResponseMessage } from '../../../utils/utils';
import { actions as authActions } from '../../../store/ducks/auth.duck';

export const useFetchLogin: any = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const fetchLogin = useCallback(
    async (payload: { login: string; password: string }) => {
      setLoading(true);
      login(payload.login, payload.password)
        .then((res) => {
          dispatch(authActions.loginSuccess(res.data));
          setSuccess(true);
        })
        .catch((e) => {
          enqueueSnackbar(`Ошибка: ${getResponseMessage(e)}`, { variant: 'error' });
        })
        .finally(() => {
          dispatch(authActions.clearLogin());
          setLoading(false);
          setErr(null);
          setSuccess(false);
        });
    },
    [dispatch]
  );

  return [fetchLogin, loading, success];
};
